<script>
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { Radio },
    props: {
      acompanhamento: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
      readonly: {
        type: Boolean,
        required: true, 
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validarDados() {
        return this.$validator.validateAll();
      },
    },
    computed: {
      validarAtividadesIniciadas() {
        if ((this.acompanhamento.atividadesIniciadas === undefined) || (this.acompanhamento.atividadesIniciadas === null))
          return 'required'
        else
          return '';
      },
      validarCronogramaCumprido() {
        if ((this.acompanhamento.cronogramaCumprido === undefined) || (this.acompanhamento.cronogramaCumprido === null))
          return 'required'
        else
          return '';
      },
      validarPlanoOrcamento() {
        if ((this.acompanhamento.planoOrcamentoCumprido === undefined) || (this.acompanhamento.planoOrcamentoCumprido === null))
          return 'required'
        else
          return '';
      },
      validarNormasRespeitadas() {
        if ((this.acompanhamento.normasRespeitadas === undefined) || (this.acompanhamento.normasRespeitadas === null))
          return 'required'
        else
          return '';
      },
      validarIntercorrencia() {
        if ((this.acompanhamento.intercorrencia === undefined) || (this.acompanhamento.intercorrencia === null))
          return 'required'
        else
          return '';
      },
    },
    mounted() {
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('atividadesIniciadas')}">
          <label class="control-label block">As atividades foram iniciadas?</label>

          <radio v-model="acompanhamento.atividadesIniciadas"
                 selected-value="true"
                 v-validate="validarAtividadesIniciadas"
                 data-vv-name="atividadesIniciadas"
                 data-vv-as="atividades"
                 type="success"
                 :inline="true"   
                 class="margin-right-10"
                 :readonly="readonly">
            Sim
          </radio>
          <radio v-model="acompanhamento.atividadesIniciadas"
                 selected-value="false"
                 v-validate="validarAtividadesIniciadas"
                 data-vv-name="atividadesIniciadas"
                 data-vv-as="atividades"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 :readonly="readonly">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('atividadesIniciadas')">{{ errors.first('atividadesIniciadas') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('atividadesIniciadasJustificativa')}">
          <label class="control-label" for="atividadesIniciadasJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="atividadesIniciadasJustificativa"
                    v-validate="'required'"
                    data-vv-name="atividadesIniciadasJustificativa"
                    data-vv-as="justificativa"             
                    v-model="acompanhamento.atividadesIniciadasJustificativa"
                    :readonly="readonly">
          </textarea>

          <p class="text-danger" v-show="errors.has('atividadesIniciadasJustificativa')">{{ errors.first('atividadesIniciadasJustificativa') }}</p>
        </div>
      </div>
    </div>   

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('cronogramaCumprido')}">
          <label class="control-label block">O cronograma de execução está sendo cumprido?</label>

          <radio v-model="acompanhamento.cronogramaCumprido"
                  selected-value="true"
                  v-validate="validarCronogramaCumprido"
                  type="success"
                  :inline="true"
                  data-vv-name="cronogramaCumprido"
                  data-vv-as="cronograma de execução"
                  class="margin-right-10"
                  :readonly="readonly">
            Sim
          </radio>
          <radio v-model="acompanhamento.cronogramaCumprido"
                  selected-value="false"
                  v-validate="validarCronogramaCumprido"
                  type="success"
                  :inline="true"
                  data-vv-name="cronogramaCumprido"
                  data-vv-as="cronograma de execução"
                  class="margin-right-10"
                  :readonly="readonly">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('cronogramaCumprido')">{{ errors.first('cronogramaCumprido') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('cronogramaCumpridoJustificativa')}">
          <label class="control-label" for="cronogramaCumpridoJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="cronogramaCumpridoJustificativa"
                    v-validate="'required'"
                    data-vv-name="cronogramaCumpridoJustificativa"
                    data-vv-as="justificativa"
                    v-model="acompanhamento.cronogramaCumpridoJustificativa"
                    :readonly="readonly">
          </textarea>

          <p class="text-danger" v-show="errors.has('cronogramaCumpridoJustificativa')">{{ errors.first('cronogramaCumpridoJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('planoOrcamentoCumprido')}">
          <label class="control-label block">O plano de trabalho/orçamento está sendo cumprido?</label>

          <radio v-model="acompanhamento.planoOrcamentoCumprido"
                  selected-value="true"
                  v-validate="validarPlanoOrcamento"
                  type="success"
                  :inline="true"                 
                  data-vv-name="planoOrcamentoCumprido"
                  data-vv-as="plano de trabalho/orçamento"
                  class="margin-right-10"
                  :readonly="readonly">
            Sim
          </radio>
          <radio v-model="acompanhamento.planoOrcamentoCumprido"
                  selected-value="false"
                  v-validate="validarPlanoOrcamento"
                  type="success"
                  :inline="true"
                  data-vv-name="planoOrcamentoCumprido"
                  data-vv-as="plano de trabalho/orçamento"
                  class="margin-right-10"
                  :readonly="readonly">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('planoOrcamentoCumprido')">{{ errors.first('planoOrcamentoCumprido') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('planoOrcamentoCumpridoJustificativa')}">
          <label class="control-label" for="planoOrcamentoCumpridoJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="planoOrcamentoCumpridoJustificativa"
                    v-validate="'required'"
                    data-vv-name="planoOrcamentoCumpridoJustificativa"
                    data-vv-as="justificativa"
                    v-model="acompanhamento.planoOrcamentoCumpridoJustificativa"
                    :readonly="readonly">
          </textarea>

          <p class="text-danger" v-show="errors.has('planoOrcamentoCumpridoJustificativa')">{{ errors.first('planoOrcamentoCumpridoJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('normasRespeitadas')}">
          <label class="control-label block">As normas legais e/ou regulamentares estão sendo cumpridas?</label>

          <radio v-model="acompanhamento.normasRespeitadas"
                  selected-value="true"
                  v-validate="validarNormasRespeitadas"
                  type="success"
                  :inline="true"
                  data-vv-name="normasRespeitadas"
                  data-vv-as="normas respeitadas"
                  class="margin-right-10"
                  :readonly="readonly">
            Sim
          </radio>
          <radio v-model="acompanhamento.normasRespeitadas"
                  selected-value="false"
                  v-validate="validarNormasRespeitadas"
                  type="success"
                  :inline="true"
                  data-vv-name="normasRespeitadas"
                  data-vv-as="normas respeitadas"
                  class="margin-right-10"
                  :readonly="readonly">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('normasRespeitadas')">{{ errors.first('normasRespeitadas') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('normasRespeitadasJustificativa')}">
          <label class="control-label" for="normasRespeitadasJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="normasRespeitadasJustificativa"
                    v-validate="'required'"
                    data-vv-name="normasRespeitadasJustificativa"
                    data-vv-as="justificativa"
                    v-model="acompanhamento.normasRespeitadasJustificativa"
                    :readonly="readonly">
          </textarea>

          <p class="text-danger" v-show="errors.has('normasRespeitadasJustificativa')">{{ errors.first('normasRespeitadasJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('intercorrencia')}">
          <label class="control-label block">Até a presente data houve alguma intercorrência durante a execução das atividades?</label>

          <radio v-model="acompanhamento.intercorrencia"
                  selected-value="true"
                 v-validate="validarIntercorrencia"
                  type="success"
                  :inline="true"
                  data-vv-name="intercorrencia"
                  data-vv-as="intercorrência"
                  class="margin-right-10"
                  :readonly="readonly">
            Sim
          </radio>
          <radio v-model="acompanhamento.intercorrencia"
                  selected-value="false"
                 v-validate="validarIntercorrencia"
                  type="success"
                  :inline="true"
                  data-vv-name="intercorrencia"
                  data-vv-as="intercorrência"
                  class="margin-right-10"
                  :readonly="readonly">
            Não
          </radio>

          <p class="text-danger" v-show="errors.has('intercorrencia')">{{ errors.first('intercorrencia') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('intercorrenciaJustificativa')}">
          <label class="control-label" for="intercorrenciaJustificativa">
            Justificativa
          </label>

          <textarea class="form-control"
                    id="intercorrenciaJustificativa"
                    v-validate="'required'"
                    data-vv-name="intercorrenciaJustificativa"
                    data-vv-as="justificativa"
                    v-model="acompanhamento.intercorrenciaJustificativa"
                    :readonly="readonly">
          </textarea>

          <p class="text-danger" v-show="errors.has('intercorrenciaJustificativa')">{{ errors.first('intercorrenciaJustificativa') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="comentariosAdicionais">
            Comentários adicionais
          </label>

          <textarea class="form-control"
                    id="comentariosAdicionais"
                    v-model="acompanhamento.comentariosAdicionais"
                    :readonly="readonly">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acompanhamento-projeto/componentes/compartilhado/FormDadosCadastraisAcomp.vue